<template>
  <div class="gold-shop-panel" id="goldShop" >
    <div class="shop-guide-hand" @click="scroll">
      <div class="hand-tips">
        <span>{{ handTips }}</span
        ><span class="hand-triangle"></span>
      </div>
    </div>
    <div class="shop-panel-top" @click="scroll">
      <div class="shop-icon"></div>
      <div class="shop-title ta-l">{{ pointMiddleTitle }}</div>
      <div class="shop-sub-title ta-l">{{ pointMiddleDesc }}</div>
    </div>
    <div class="shop-panel-body" :class="newUserType!=1?'':'bottomPadding'">
      <div class="gold-board">
        <div class="my-egg">
          <div class="change-tips" v-if="canChangeGold != 0">
            <span >{{ pointMiddleBannerBubble }}</span><span class="triangle"></span>
          </div>
          <div class="num udc-bold">{{ eggNumFix }}</div>
          <div class="text">我的鹅蛋数量</div>
        </div>
        <div class="my-gold">
          <div class="num udc-bold">{{ goldNumFix }}</div>
          <div class="text">{{ pointMiddleBannerNumDesc }}</div>
        </div>
        <div class="change-btn" v-if="canChangeGold != 0" @click="changeGold" clstag="A05R|clk_transfer_go">立即兑换</div>
        <div class="change-btn-disable" v-else>立即兑换</div>
      </div>
      <div class="gold-banner" v-if="gcBannerList.length">
        <swiper class="swiper" :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in gcBannerList" :key="item.id">
            <div class="banner-item">
              <a :href="item.jumpData.jumpUrl || 'javascript:;'">
                <!-- <img :src="item.imgUrl" class="pct100"/> -->
                <JrmcBaseImg :src="item.imgUrl" class="pct100"></JrmcBaseImg>
              </a>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination" v-if="gcBannerList.length > 1"></div>
        </swiper>
      </div>
      <template v-if="newUserType!=1">
      <div class="gold-switch-tab">
        <div class="gold-tab-item" :class="switchIndex == 0 ? 'gold-current-tab' : ''" @click="changeSwitchTab(0, 48)" clstag="A05R|12821">
          热门兑换
        </div>
        <!-- <div class="gold-tab-item" :class="switchIndex == 1 ? 'gold-current-tab' : ''" @click="changeSwitchTab(1, 49)" clstag="A05R|12822">
          1万金币以下
        </div>
        <div class="gold-tab-item" :class="switchIndex == 2 ? 'gold-current-tab' : ''" @click="changeSwitchTab(2, 50)" clstag="A05R|12823">
          1万金币以上
        </div> -->
      </div>
      <div class="gold-list" v-if="gcMallObjectVos.length">
        <div class="good-item" v-for="(item, index) in gcMallObjectVos" :key="item.id">
          <div class="good-item-top">
            <div class="good-item-img" @click="goSkuUrl(item.link)">
              <!-- <img class="pct100" :src="item.imgUrl" alt="" /> -->
              <JrmcBaseImg class="pct100" :src="item.imgUrl"></JrmcBaseImg>
            </div>
            <div class="good-item-name">{{ item.name }}</div>
            <div class="good-item-soldout" v-if="item.exchangeStatus == 3"></div>
          </div>
          <div class="good-item-foot-disable" v-if="item.exchangeStatus == 3">
            <div class="amount-gold">
              <span class="udc-bold">{{ item.amount }}</span> {{scoreUnits}}
            </div>
            <div class="good-item-foot-btn">已抢光</div>
          </div>
          <div class="good-item-foot-disable" v-else-if="goldNum < item.amount">
            <div class="amount-gold">
              <span class="udc-bold">{{ item.amount }}</span> {{scoreUnits}}
            </div>
            <div class="good-item-foot-btn">{{scoreUnits}}不足</div>
          </div>
          <div class="good-item-foot" v-else>
            <div class="amount-gold">
              <span class="udc-bold">{{ item.amount }}</span> {{scoreUnits}}
            </div>
            <a class="good-item-foot-btn" :href="item.link" clstag="A05R|SKU" :data-qidian-ext="JSON.stringify({posid:index+1})">去兑换</a>
          </div>
        </div>
      </div>
      <div class="gold-empty" v-else>
        <h6 class="gold-empty-img"></h6>
        <h6 class="gold-empty-text">商品上新中，敬请期待</h6>
      </div>
      <a @click="jumpUrl" class="good-more-link" clstag="A05R|clk_transfer_more">查看更多商品 <span class="more-icon"></span></a>
      </template>
    </div>
  </div>
</template>
<style rel="stylesheet/scss" lang="scss">
.gold-shop-panel {
  .shop-panel-top {
    height: 1rem;
    width: 100%;
    background: url(#{$path}/home/shop-panel-top.png) no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    z-index: 2;
  }
  .shop-guide-hand {
    width: 0.33rem;
    height: 0.39rem;
    @include singleBg;
    background-image: url(#{$path}/shop/hand.png);
    position: absolute;
    right: 0.32rem;
    top: -0.05rem;
    .hand-tips {
      position: absolute;
      top: -0.3rem;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.5);
      border-radius: 0.2rem;
      padding: 0 0.08rem;
      white-space: nowrap;
      font-size: 0.12rem;
      height: 0.25rem;
      line-height: 0.25rem;
      color: #fff74b;
      font-weight: bold;
    }
    .hand-triangle {
      position: absolute;
      left: 50%;
      margin-left: -0.05rem;
      top: 0.25rem;
      border-width: 0.05rem;
      border-style: solid;
      border-color: rgba(0, 0, 0, 0.5) transparent transparent transparent;
    }
  }
  .shop-icon {
    position: absolute;
    left: 0.15rem;
    top: -0.33rem;
    width: 0.73rem;
    height: 0.53rem;
    background-image: url(#{$path}/home/shop-icon.png);
    @include singleBg;
  }
  .shop-title {
    color: #421c92;
    font-size: 0.2rem;
    font-weight: bold;
    position: absolute;
    left: 0.15rem;
    top: 0.3rem;
    line-height: 1;
  }
  .shop-sub-title {
    color: #421c92;
    font-size: 0.12rem;
    position: absolute;
    left: 0.15rem;
    top: 0.6rem;
    line-height: 1;
  }
  .shop-panel-body {
    background: #f3f5ff;
    margin-top: -0.08rem;
    position: relative;
    z-index: 2;
    .gold-board {
      width: 3.45rem;
      height: 0.9rem;
      background-image: linear-gradient(180deg, #8e50ff 0%, #3450e6 100%);
      border-radius: 0.05rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
    }
    .my-egg {
      position: relative;
      margin-left: 0.25rem;
    }
    .num {
      font-size: 0.28rem;
      line-height: 1.1;
    }
    .text {
      font-size: 0.12rem;
    }
    .change-btn {
      width: 0.86rem;
      height: 0.35rem;
      line-height: 0.35rem;
      color: #4d3bff;
      background-image: linear-gradient(0deg, #ffe84a 0%, #ffec88 100%);
      border-radius: 0.23rem;
      font-size: 0.14rem;
      font-weight: bold;
      margin-right: 0.15rem;
    }
    .change-btn-disable {
      width: 0.86rem;
      height: 0.35rem;
      line-height: 0.35rem;
      color: #fff;
      background-color: #c9c9c9;
      border-radius: 0.23rem;
      font-size: 0.14rem;
      margin-right: 0.15rem;
    }
    .change-tips {
      position: absolute;
      top: -0.32rem;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(255, 84, 202, 0.9);
      border-radius: 0.2rem;
      padding: 0 0.15rem;
      white-space: nowrap;
      font-size: 0.12rem;
      height: 0.26rem;
      line-height: 0.26rem;
      z-index: 2;
      font-weight: bold;

      span {
        display: inline-block;
        width: auto;
        max-width: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .triangle {
        position: absolute;
        left: 50%;
        margin-left: -0.05rem;
        top: 0.26rem;
        border-width: 0.05rem;
        border-style: solid;
        border-color: rgba(255, 84, 202, 0.9) transparent transparent transparent;
      }
    }
  }
  .bottomPadding{
  padding-bottom:0.2rem;
}
  .gold-switch-tab {
    display: flex;
    justify-content: space-between;
    padding: 0 0.25rem;
    color: #3543d8;
    font-size: 0.13rem;
    margin-top: 0.25rem;
  }
  .gold-tab-item {
    background: rgba(56, 87, 255, 0.1);
    border-radius: 0.2rem;
    width: 1rem;
    height: 0.35rem;
    line-height: 0.35rem;
    font-weight: bold;
  }
  .gold-current-tab {
    background: #ffffff;
    box-shadow: 0 0.02rem 0.12rem 0 rgba(42, 70, 223, 0.25);
  }
  .gold-list {
    display: flex;
    padding: 0 0.15rem;
    justify-content: space-between;
    margin-top: 0.15rem;
    flex-wrap: wrap;
  }
  .gold-empty {
    width: 100%;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .gold-empty-img {
    width: 1.49rem;
    height: 1.02rem;
    background-image: url(#{$path}/shop/empty-img.png);
    @include singleBg;
  }
  .gold-empty-text {
    margin-top: 0.2rem;
    color: rgba(102, 102, 102, 0.8);
    font-size: 0.14rem;
  }
  .good-item {
    width: 1.68rem;
    margin-bottom: 0.1rem;
  }
  .good-item-top {
    width: 1.68rem;
    height: 1.58rem;
    background-color: #fff;
    border-radius: 0.08rem 0.08rem 0 0;
    padding-top: 0.1rem;
    position: relative;
  }
  .good-item-img {
    width: 1rem;
    height: 1rem;
    border-radius: 0.05rem;
    overflow: hidden;
    position: relative;
    margin: 0 auto;
  }
  .good-item-name {
    text-align: center;
    color: #333;
    font-size: 0.13rem;
    margin-top: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 0.18rem;
    height: 0.36rem;
    word-break: break-all;
    padding: 0 0.1rem;
    font-weight: bold;
  }
  .good-item-foot {
    display: flex;
    width: 100%;
    height: 0.4rem;
    background-image: linear-gradient(90deg, #ff9718 0%, #ff6100 100%);
    border-radius: 0 0 0.08rem 0.08rem;
    justify-content: space-between;
    align-items: center;
  }
  .good-item-foot-disable {
    display: flex;
    width: 100%;
    height: 0.4rem;
    background-color: #c1c1c1;
    border-radius: 0 0 0.08rem 0.08rem;
    justify-content: space-between;
    align-items: center;
  }
  .good-item-foot-btn {
    color: #fff;
    width: 0.72rem;
    font-size: 0.14rem;
    line-height: 0.4rem;
    height: 0.4rem;
    position: relative;
    font-weight: bold;
    &:before {
      content: '';
      width: 0.005rem;
      height: 0.2rem;
      background-color: #fff;
      opacity: 0.3;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -0.1rem;
    }
  }
  .gold-change-btn {
    display: block;
    background: linear-gradient(135deg, rgba(255, 151, 24, 1) 0%, rgba(255, 113, 12, 1) 100%);
    width: 1.05rem;
    height: 0.3rem;
    color: #fff;
    font-size: 0.13rem;
    line-height: 0.3rem;
    margin-top: 0.05rem;
    border-radius: 2rem;
  }
  .gold-change-btn-disable {
    display: block;
    background: #cacaca;
    width: 1.05rem;
    height: 0.3rem;
    color: #fff;
    font-size: 0.13rem;
    line-height: 0.3rem;
    margin-top: 0.05rem;
    border-radius: 2rem;
  }
  .good-item-soldout {
    width: 0.6rem;
    height: 0.6rem;
    position: absolute;
    right: 0;
    bottom: 0.475rem;
    background: url(../assets/images/icon_soldout.png) no-repeat center center;
    background-size: 100%;
    pointer-events: none;
  }
  .amount-gold {
    text-align: left;
    font-size: 0.12rem;
    color: #d85d00;
    padding-left: 0.1rem;
    color: #fff;
    font-weight: bold;
    line-height: 0.4rem;
    span {
      font-size: 0.15rem;
    }
  }
  .good-more-link {
    margin-top: 0.1rem;
    display: flex;
    color: #462c9e;
    font-size: 0.15rem;
    font-weight: bold;
    padding-bottom: 0.2rem;
    justify-content: center;
    align-items: center;
  }
  .more-icon {
    display: block;
    width: 0.06rem;
    height: 0.1rem;
    background: url(#{$path}/shop/more-icon.png) no-repeat center center;
    background-size: contain;
    margin-left: 0.08rem;
  }
  .gold-banner {
    margin-top: 0.15rem;
  }
  .banner-item {
    height: 0.6rem;
    padding: 0 0.15rem;
    width: 100%;
    box-sizing: border-box;
    a {
      display: block;
    }
  }
  .swiper-pagination {
    position: relative;
    bottom: 0;
  }
  .swiper-pagination-bullet {
    width: 0.06rem;
    height: 0.06rem;
    border-radius: 0.1rem;
    overflow: hidden;
    margin: 0 0.03rem !important;
  }
  .swiper-pagination-bullet-active {
    background-color: #97a7ff;
  }
}
</style>
<script type="javascript">
import Tools from '../scripts/tools';
import proHub from '../scripts/proHub';
import Dialog from '../components/Dialog'
import {gsap} from "gsap";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import '@jd/yt-comp/release/online/static/latest/css/swiper.css';
import {swiper, swiperSlide, directive} from 'vue-awesome-swiper';
//Global
import Global from './../scripts/Global';

export default {
    data() {
        return {
            rate: 10,
            goldNum: 0,
            gcMallObjectVos: [],
            gcBannerList: [],
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            switchIndex: 0,
            tabData: {},
            handTipAry: [{'text': '下面有好物哦'}],
            handTipIndex: 0,
            // 2021-03-22 
            pointMiddleTitle: '兑换商店',   // 标题
            pointMiddleDesc: '卖鹅蛋（鹅蛋有有效期），及时兑换，换好礼！',    // 描述
            pointMiddleBannerBubble: '暂无兑换',    // 气泡
            pointMiddleBannerNumDesc: '我的',    // 积分数量描述
            showShop: false,
            newUserType:0, // 0:正常用户 1:风控用户 2：需要滑块验证用户
            isStop:window.data_source_100003725?.systemConfig?.isStop||false,
        }
    },
    components: {
        Dialog,
        swiper,
        swiperSlide
    },
    props: {
        eggNum: Number,
        scoreUnits: {
            type: String,
            default: ''
        },
        enablePoint: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
        canChangeGold() {
          if(this.isStop){
            return Tools.fixMoney(Math.ceil(this.eggNum / this.rate));
          }else{
            return Tools.fixMoney(parseInt(this.eggNum / this.rate));
          }
        },
        eggNumFix() {
            return Tools.fixMoney(this.eggNum);
        },
        goldNumFix() {
            return Tools.fixMoney(this.goldNum);
        },
        loadingProgress() {
            return this.loadingPercent * 100 + '%'
        },
        handTips() {
            if (this.handTipAry.length > 0) return this.handTipAry[this.handTipIndex].text
             return '下面有好物哦'
        }
    },
    watch: {
        canChangeGold: {
            deep: true,
            handler (val) {
                // console.log('鹅蛋数量：', val)
                this.getFloorData(48)
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollFn, true)
        // this.getFloorData()
        if (Global.goldShopBannerData && Global.goldShopBannerData.templateData) {
            this.gcBannerList = Global.goldShopBannerData.templateData.elementList
        }
        if (Global.guideHandText && Global.guideHandText.templateData) {
            let targetAry = [];
            for (let i = 0; i < Global.guideHandText.templateData.elementList.length; i++) {
                if (Global.guideHandText && 
                    Global.guideHandText.templateData &&
                    Global.guideHandText.templateData.elementList[i] &&
                    Global.guideHandText.templateData.elementList[i].text &&
                    Global.guideHandText.templateData.elementList[i].text.length <= 7) {
                    targetAry.push(Global.guideHandText.templateData.elementList[i])
                }
            }
            this.handTipAry = targetAry;
            this.handTipRefresh();
        }
        if(this.isStop){
          this.scroll()
        }
    },
    beforeDestroy() {
        clearTimeout(this.tipsTimer);
    },
    methods: {
        goSkuUrl(url){
            // console.log('gg', Global)
            this.$jumpUrl(url)
        },
        handTipRefresh() {
            clearTimeout(this.tipsTimer);
            this.tipsTimer = setTimeout(() => {
                if (this.handTipIndex >= (this.handTipAry.length - 1)) {
                    this.handTipIndex = 0;
                } else {
                    this.handTipIndex++
                }
                this.handTipRefresh();
            }, 3500)
        },
        getFloorData(floorId) {
          // 防刷与风控
              let signData = {
                channelLv: Global.channelLv||"ttte",
                environment: Global.currentSystem||"jrApp",
                riskDeviceInfo: Global.riskDeviceInfo,
                shareUuid: Global.inviteId||"uuid",
              };
              let parameters = {
              qdPageId: 'A05R',
              mdClickId: '',
              pageUrl: window.location.href,
              urlKey: window.location.origin + window.location.pathname,
              isSlider:0,
              };
            proHub.newPost('queryGoldExchange', {
              riskDeviceInfo: Global.riskDeviceInfo,
              parameters: parameters,
              signData: signData,
              environment: Global.currentSystem||"jrApp",
              channelLv: Global.channelLv||"ttte",
              shareUuid: Global.inviteId||"uuid",
            }, (e) => {
                this.newUserType = e.data?.userType||0
                this.rate = e.data.rate;
                this.goldNum = e.data.goldTotal;
                // 2021-03-22 接口新增（标题、描述、气泡、积分数量描述）
                if (e.data.pointMiddleTitle) this.pointMiddleTitle = e.data.pointMiddleTitle
                if (e.data.pointMiddleDesc) this.pointMiddleDesc = e.data.pointMiddleDesc
                if (e.data.pointMiddleBannerBubble) this.pointMiddleBannerBubble = e.data.pointMiddleBannerBubble
                if (e.data.pointMiddleBannerNumDesc) this.pointMiddleBannerNumDesc = e.data.pointMiddleBannerNumDesc

                if (!e.data.gcMallObjectVos) return;
                // let itemLength = e.data.gcMallObjectVos.length;
                //let sliceLength = Math.min(parseInt(itemLength / 3) * 3, 9);
                //this.tabData[floorId] = e.data.gcMallObjectVos.slice(0, sliceLength);
                this.tabData[floorId] = e.data.gcMallObjectVos
                this.gcMallObjectVos = this.tabData[floorId];
            })
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (scrollTop <= 50) {
                gsap.registerPlugin(ScrollToPlugin);
                gsap.to(window, {duration: 0.2, scrollTo: 400})
            }
        },
        changeGold() {
            // 立刻兑换
            this.$emit('change-gold', {goldNum: this.goldNum, rate: this.rate})
        },
        refreshGold(goldNum) {
            this.goldNum = goldNum;
        },
        changeSwitchTab(index, floorId) {
            if (this.switchIndex == index) return;
            this.switchIndex = index;
            if (this.tabData[floorId]) {
                this.gcMallObjectVos = this.tabData[floorId];
            } else {
                this.getFloorData(floorId);
            }

        },
        jumpUrl () {
            // 金币 https://member.jr.jd.com/gcmall/?channel=01-ttte-200205
            // 积分 https://member.jr.jd.com/member/integralmall/#/index?channel=002
            // let url = this.enablePoint ? 'https://member.jr.jd.com/member/integralmall/#/index?channel=002' : 'https://member.jr.jd.com/gcmall/?channel=01-ttte-200205'
            // window.location.href = url
            if (window.data_source_100003725) {
                const { otherConfig = {} } = window.data_source_100003725;
                let url = otherConfig && otherConfig.moreShopUrl;
                this.$jumpUrl(url)
            }
        },
        scrollFn(){
          if(this.showShop){ 
            window.removeEventListener('scroll', this.scrollFn, true);
            return false;
          }
          const el = document.getElementById('goldShop')
          if(!el) return false;
          const pos = el.getBoundingClientRect()
          const windowHeight = window.screen.height
          if( pos.y - windowHeight > 100) return false;
          if(this.showShop) return false;
          this.getFloorData()
          this.showShop = true
          window.removeEventListener('scroll', this.scrollFn)
        },
    }
}
</script>
